/**
 * ⚠️  AUTO-GENERATED FILE - DO NOT EDIT MANUALLY ⚠️
 *
 * This file is generated by generate-feature-flags.ts from feature-flags-registry.json.
 * To add or modify feature flags, edit feature-flags-registry.json and run: npm run generate:feature-flags
 *
 * @generated
 * @hash 1dc671a438d7f989
 */

const CommunitiesFlags = [
  // Enables the Community Creator Analytics page, gated by Groups API product-features
  'CreatorAnalytics',
] as const;

export default CommunitiesFlags;
